import { FilterOption, SearchItem } from '../input/WorkflowSearchTypes';

import { CompletionStatus } from '@/client/services/api/graphql/gql/graphql';
import { create } from 'zustand';

interface CompletionStatusOption {
  label: string;
  value: CompletionStatus | undefined;
}

interface WorkflowSearchState {
  selectedItems: SearchItem[];
  setSelectedItems: (items: SearchItem[]) => void;
  filterOptions: FilterOption[];
  setFilterOptions: (options: FilterOption[]) => void;
  selectedFilterOption: FilterOption;
  setSelectedFilterOption: (option: FilterOption) => void;
  selectedCompletionStatus: CompletionStatusOption | null;
  setSelectedCompletionStatus: (status: CompletionStatusOption | null) => void;
}

export const useWorkflowSearchStore = create<WorkflowSearchState>((set) => ({
  selectedItems: [],
  setSelectedItems: (items) => set({ selectedItems: items }),
  filterOptions: [],
  setFilterOptions: (options) => set({ filterOptions: options }),
  selectedFilterOption: { label: 'Assignments', value: 'assignments' },
  setSelectedFilterOption: (option) => set({ selectedFilterOption: option }),
  selectedCompletionStatus: null,
  setSelectedCompletionStatus: (status) => set({ selectedCompletionStatus: status }),
}));
